var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentZip = function SvgDocumentZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#documentZip_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD396",
    d: "M27.666 35H7.334a2.905 2.905 0 0 1-2.905-2.905V2.905C4.43 1.3 5.73 0 7.334 0h13.33c.743 0 1.457.284 1.996.795l7.002 6.624c.58.548.909 1.311.909 2.11v22.566c0 1.605-1.3 2.905-2.905 2.905"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB554",
    d: "M29.662 7.419 22.66.795A2.9 2.9 0 0 0 20.664 0H17.5v35h10.166c1.604 0 2.905-1.3 2.905-2.905V9.53c0-.799-.329-1.562-.909-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E38100",
    d: "M22.873 8.714h7.58a2.9 2.9 0 0 0-.79-1.295L22.66.795A2.9 2.9 0 0 0 21.421.1v7.16c0 .802.65 1.453 1.452 1.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.182 30.31h1.482V31H7.228v-.678l1.452-1.956H7.234v-.69h2.412v.678zm2.558-3.03a.53.53 0 0 1-.372-.138.48.48 0 0 1-.144-.354q0-.21.144-.348a.52.52 0 0 1 .372-.144q.222 0 .366.144.15.138.15.348t-.15.354a.5.5 0 0 1-.366.138m.414.396V31h-.84v-3.324zm1.67.48q.162-.228.444-.378a1.35 1.35 0 0 1 .654-.156 1.44 1.44 0 0 1 1.314.81q.204.384.204.894t-.204.906q-.198.39-.546.606a1.4 1.4 0 0 1-.768.216q-.366 0-.648-.15a1.4 1.4 0 0 1-.45-.378v2.058h-.84v-4.908h.84zm1.758 1.17q0-.3-.126-.516a.85.85 0 0 0-1.188-.33.9.9 0 0 0-.324.336q-.12.222-.12.522t.12.522a.9.9 0 0 0 .324.342q.204.114.432.114.234 0 .432-.12a.86.86 0 0 0 .324-.342q.126-.222.126-.528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "documentZip_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v35H0z"
  })))));
};
export default SvgDocumentZip;